// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var FormV5 = require("../../../uikit/reason/atoms/Form/FormV5.bs.js");
var DragDrop = require("../../../reason/settings/components/dragDrop/DragDrop.bs.js");
var ReactDnd = require("../../../reason/bindings/ReactDnd.bs.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Core__List = require("@rescript/core/src/Core__List.bs.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var View__Jsx3 = require("../../../uikit/reason/helpers/View__Jsx3.bs.js");
var Attachments = require("../../../reason/common/Attachments/Attachments.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var AttachmentFormUtils = require("./AttachmentFormUtils.bs.js");
var Styles = require("components/NewProperty/NewPropertyAttachments/styles");
var InitialUploadPrompt = require("components/NewProperty/NewPropertyAttachments/InitialUploadPrompt").default;
var UploadProgressIndicator = require("components/NewProperty/NewPropertyAttachments/UploadProgressIndicator").default;

var UploadList = {};

var UploadStatusItem = {};

var UploadStatusItemInner = {};

var FileBarWrapper = {};

var FileNameWrapper = {};

var FileOrder = {};

var RemoveButtonWrapper = {};

var FileName = {};

var AttachmentItemContent = {};

var ErrorContent = {};

var ErrorContentTitle = {};

var ImageContent = {};

var AttachmentItem = {};

var MainImageLabel = {};

var UploadIndicatorWrapper = {};

var UploadProgressIndicator$1 = {};

var AddFileItemWrapper = {};

var AddFileItemInner = {};

var AddFileItemInnerContent = {};

var StyleComponents = {
  UploadList: UploadList,
  UploadStatusItem: UploadStatusItem,
  UploadStatusItemInner: UploadStatusItemInner,
  FileBarWrapper: FileBarWrapper,
  FileNameWrapper: FileNameWrapper,
  FileOrder: FileOrder,
  RemoveButtonWrapper: RemoveButtonWrapper,
  FileName: FileName,
  AttachmentItemContent: AttachmentItemContent,
  ErrorContent: ErrorContent,
  ErrorContentTitle: ErrorContentTitle,
  ImageContent: ImageContent,
  AttachmentItem: AttachmentItem,
  MainImageLabel: MainImageLabel,
  UploadIndicatorWrapper: UploadIndicatorWrapper,
  UploadProgressIndicator: UploadProgressIndicator$1,
  AddFileItemWrapper: AddFileItemWrapper,
  AddFileItemInner: AddFileItemInner,
  AddFileItemInnerContent: AddFileItemInnerContent
};

function AttachmentFormSection$FileBar(props) {
  return JsxRuntime.jsxs(Styles.FileBarWrapper, {
              children: [
                JsxRuntime.jsxs(Styles.FileNameWrapper, {
                      children: [
                        JsxRuntime.jsx(Styles.FileOrder, {
                              children: String(props.index + 1 | 0)
                            }),
                        JsxRuntime.jsx(Styles.FileName, {
                              children: props.fileName
                            })
                      ]
                    }),
                JsxRuntime.jsx(Styles.RemoveButtonWrapper, {
                      onClick: props.onDeleteAttachment,
                      children: JsxRuntime.jsx(Icon__Jsx3.make, {
                            icon: "Trash"
                          })
                    })
              ]
            });
}

var FileBar = {
  make: AttachmentFormSection$FileBar
};

function AttachmentFormSection$AttachmentItemContent(props) {
  var content = props.content;
  var tmp;
  if (typeof content !== "object") {
    tmp = JsxRuntime.jsx(Icon__Jsx3.make, {
          icon: "FilePdf",
          size: 60
        });
  } else if (content.TAG === "Error") {
    tmp = JsxRuntime.jsxs(Styles.ErrorContent, {
          children: [
            JsxRuntime.jsx(Icon__Jsx3.make, {
                  icon: "Error",
                  size: 40
                }),
            JsxRuntime.jsx(Styles.ErrorContentTitle, {
                  children: content._0
                })
          ]
        });
  } else {
    var preview = content._0;
    tmp = preview !== undefined ? JsxRuntime.jsx(Styles.ImageContent, {
            src: preview,
            alt: ""
          }) : JsxRuntime.jsx(Icon__Jsx3.make, {
            icon: "Image",
            size: 70
          });
  }
  return JsxRuntime.jsx(Styles.StyledAttachmentItemContent, {
              children: tmp
            });
}

var AttachmentItemContent$1 = {
  make: AttachmentFormSection$AttachmentItemContent
};

function AttachmentFormSection$AttachmentItem(props) {
  var isImage = props.isImage;
  var error = props.error;
  var content = error !== undefined ? ({
        TAG: "Error",
        _0: error
      }) : (
      isImage ? ({
            TAG: "Image",
            _0: props.previewUrl
          }) : "File"
    );
  return JsxRuntime.jsxs(Styles.StyledAttachmentItem, {
              uploaded: props.isUploaded,
              draggable: isImage,
              children: [
                props.isMain && isImage ? JsxRuntime.jsx(Styles.MainImageLabel, {
                        children: "Main"
                      }) : null,
                JsxRuntime.jsx(AttachmentFormSection$AttachmentItemContent, {
                      content: content
                    }),
                JsxRuntime.jsx(AttachmentFormSection$FileBar, {
                      index: props.index,
                      fileName: props.fileName,
                      onDeleteAttachment: props.onDeleteAttachment
                    })
              ]
            });
}

var AttachmentItem$1 = {
  make: AttachmentFormSection$AttachmentItem
};

function type_(param) {
  return "ATTACHMENT";
}

var Item = {
  type_: type_
};

var ReactDnd$1 = ReactDnd.Make(Item);

function hover(ref, reorder, id, index, item, monitor) {
  var dragIndex = item.index;
  var match = ReactDnd$1.DropTargetMonitor.getClientOffset(monitor);
  var match$1 = ref.current;
  if (match === undefined) {
    return ;
  }
  if (match$1 == null) {
    return ;
  }
  var hoverBoundingRect = match$1.getBoundingClientRect();
  var hoverMiddleX = ((hoverBoundingRect.right | 0) - (hoverBoundingRect.left | 0) | 0) / 2 | 0;
  var hoverClientX = match.x - (hoverBoundingRect.left | 0) | 0;
  var isDraggingRight = dragIndex < index && hoverClientX < hoverMiddleX;
  var isDraggingLeft = dragIndex > index && hoverClientX > hoverMiddleX;
  if (isDraggingLeft || isDraggingRight) {
    return reorder(item.id, id);
  }
  
}

function collect(monitor, _props) {
  var isDragging = ReactDnd$1.DragSourceMonitor.isDragging(monitor);
  return {
          isDragging: isDragging
        };
}

function AttachmentFormSection$UploadStatus(props) {
  var uploadDone = props.uploadDone;
  var reorder = props.reorder;
  var id = props.id;
  var isImage = props.isImage;
  var index = props.index;
  var domRef = React.useRef(null);
  var match = ReactDnd$1.useDrag(undefined, collect, {
        id: id,
        index: index
      }, undefined);
  var match$1 = ReactDnd$1.useDrop(undefined, (function (extra, extra$1) {
          return hover(domRef, reorder, id, index, extra, extra$1);
        }), "ATTACHMENT", undefined);
  if (isImage) {
    match$1[1](match[1](domRef));
  }
  var opacity = match[0].isDragging ? 0 : 1;
  return JsxRuntime.jsx(Styles.UploadStatusItem, {
              opacity: opacity,
              ref: domRef,
              children: JsxRuntime.jsxs(Styles.UploadStatusItemInner, {
                    children: [
                      JsxRuntime.jsx(AttachmentFormSection$AttachmentItem, {
                            error: props.error,
                            fileName: props.fileName,
                            index: index,
                            isUploaded: uploadDone,
                            isImage: isImage,
                            isMain: props.isMain,
                            onDeleteAttachment: props.onDeleteAttachment,
                            previewUrl: props.previewUrl
                          }),
                      uploadDone ? null : JsxRuntime.jsx(Styles.UploadIndicatorWrapper, {
                              children: JsxRuntime.jsx(UploadProgressIndicator, {
                                    progress: props.progress * 100
                                  })
                            })
                    ]
                  })
            });
}

var UploadStatus = {
  Item: Item,
  ReactDnd: ReactDnd$1,
  hover: hover,
  collect: collect,
  make: AttachmentFormSection$UploadStatus
};

function AttachmentFormSection$FileInputLink(props) {
  var onChange = props.onChange;
  var inputEl = React.useRef(null);
  var onChange$1 = function (evt) {
    onChange(evt.target.files);
    var node = inputEl.current;
    if (!(node == null)) {
      node.value = "";
      return ;
    }
    
  };
  var onClick = function (evt) {
    evt.preventDefault();
    var node = inputEl.current;
    if (!(node == null)) {
      return node.click();
    }
    
  };
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("input", {
                      ref: Caml_option.some(inputEl),
                      style: {
                        height: "0",
                        left: "-9999px",
                        position: "absolute",
                        visibility: "hidden",
                        width: "0"
                      },
                      multiple: props.multiple,
                      type: "file",
                      onChange: onChange$1
                    }),
                JsxRuntime.jsx("a", {
                      children: props.children,
                      href: "",
                      onClick: onClick
                    })
              ]
            });
}

var FileInputLink = {
  make: AttachmentFormSection$FileInputLink
};

function AttachmentFormSection$AddFileItem(props) {
  return JsxRuntime.jsx(Styles.AddFileItemWrapper, {
              children: JsxRuntime.jsx(AttachmentFormSection$FileInputLink, {
                    onChange: props.onChange,
                    multiple: props.multiple,
                    children: props.children
                  })
            });
}

var AddFileItem = {
  make: AttachmentFormSection$AddFileItem
};

function AttachmentFormSection$UploadList(props) {
  var uploads = props.uploads;
  var reorder = props.reorder;
  var onUploadStatusChange = props.onUploadStatusChange;
  var onDeleteAttachment = props.onDeleteAttachment;
  var isImage = props.isImage;
  var isUploading = Core__Option.mapOr(uploads.find(function (attachment) {
            var match = attachment.state;
            if (match.TAG === "InProgress") {
              return true;
            } else {
              return false;
            }
          }), false, (function (param) {
          return true;
        }));
  React.useEffect((function () {
          if (onUploadStatusChange !== undefined) {
            onUploadStatusChange(isUploading);
          }
          
        }), [isUploading]);
  return JsxRuntime.jsxs(Styles.UploadListUl, {
              isImage: isImage,
              children: [
                uploads.map(function (u, i) {
                      var match = u.state;
                      var error;
                      error = match.TAG === "Failed" ? "upload failed" : undefined;
                      var match$1 = u.state;
                      var isUploaded;
                      isUploaded = match$1.TAG === "Success" ? true : false;
                      var match$2 = u.state;
                      var progress;
                      switch (match$2.TAG) {
                        case "InProgress" :
                            progress = match$2._1;
                            break;
                        case "NotStarted" :
                        case "Failed" :
                            progress = 0;
                            break;
                        case "Success" :
                            progress = 1;
                            break;
                        
                      }
                      var isMain = isImage && i === 0;
                      return JsxRuntime.jsx(AttachmentFormSection$UploadStatus, {
                                  error: error,
                                  fileName: Attachments.Attachment.fileName(u),
                                  index: i,
                                  isImage: isImage,
                                  isMain: isMain,
                                  onDeleteAttachment: (function () {
                                      onDeleteAttachment(Attachments.Attachment.id(u));
                                    }),
                                  id: Attachments.Attachment.id(u),
                                  previewUrl: u.previewUrl,
                                  progress: progress,
                                  reorder: reorder,
                                  uploadDone: isUploaded
                                }, Attachments.Attachment.id(u));
                    }),
                props.showAddFile ? JsxRuntime.jsx(AttachmentFormSection$AddFileItem, {
                        multiple: true,
                        onChange: props.onAddAttachments,
                        children: JsxRuntime.jsx(Styles.AddFileItemInner, {
                              children: JsxRuntime.jsxs(Styles.AddFileItemInnerContent, {
                                    children: [
                                      JsxRuntime.jsx(Icon__Jsx3.make, {
                                            icon: "Add",
                                            size: 45
                                          }),
                                      JsxRuntime.jsx("span", {
                                            children: "Add file",
                                            className: "add-file-text"
                                          })
                                    ]
                                  })
                            })
                      }) : null
              ]
            });
}

var UploadList$1 = {
  Attachment: undefined,
  make: AttachmentFormSection$UploadList
};

function AttachmentFormSection$FileUploadList(props) {
  return JsxRuntime.jsx(AttachmentFormSection$UploadList, {
              isImage: false,
              onAddAttachments: props.onAddAttachments,
              onDeleteAttachment: props.onDeleteAttachment,
              onUploadStatusChange: props.onUploadStatusChange,
              reorder: props.reorder,
              showAddFile: false,
              uploads: props.uploads
            });
}

var FileUploadList = {
  make: AttachmentFormSection$FileUploadList
};

function AttachmentFormSection$ImageUploadList(props) {
  return JsxRuntime.jsx(AttachmentFormSection$UploadList, {
              isImage: true,
              onAddAttachments: props.onAddAttachments,
              onDeleteAttachment: props.onDeleteAttachment,
              onUploadStatusChange: props.onUploadStatusChange,
              reorder: props.reorder,
              showAddFile: true,
              uploads: props.uploads
            });
}

var ImageUploadList = {
  make: AttachmentFormSection$ImageUploadList
};

function AttachmentFormSection(props) {
  var updateFiles = props.updateFiles;
  var updateImages = props.updateImages;
  var filesResult = props.filesResult;
  var imagesResult = props.imagesResult;
  var files = props.files;
  var images = props.images;
  var imagesList = Core__List.fromArray(images);
  var filesList = Core__List.fromArray(files);
  var updateImages$1 = function (v) {
    updateImages(Core__List.toArray(v));
  };
  var updateFiles$1 = function (v) {
    updateFiles(Core__List.toArray(v));
  };
  var onUnsupportedFileError = Attachments.useUnsupportedFilesSystemMessage();
  var i = Attachments.useAttachments(updateImages$1, imagesList, onUnsupportedFileError);
  var f = Attachments.useAttachments(updateFiles$1, filesList, onUnsupportedFileError);
  var imageUploadInProgress = AttachmentFormUtils.anyInProgress(images);
  var fileUploadInProgress = AttachmentFormUtils.anyInProgress(files);
  var add = function (extra) {
    var addImages = i.add;
    var addFiles = f.add;
    var match = Belt_Array.partition(extra, (function (file) {
            var contentType = file.type;
            return Attachments.Attachment.ContentType.isImage(contentType);
          }));
    var files = match[1];
    var images = match[0];
    if (images.length > 0) {
      addImages(images);
    }
    if (files.length > 0) {
      return addFiles(files);
    }
    
  };
  var match = i.attachments.concat(f.attachments);
  var tmp;
  var exit = 0;
  if (filesResult !== undefined && !(filesResult.TAG === "Ok" || fileUploadInProgress)) {
    tmp = JsxRuntime.jsx(FormV5.$$Error.make, {
          children: filesResult._0
        });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = imagesResult !== undefined && !(imagesResult.TAG === "Ok" || imageUploadInProgress) ? JsxRuntime.jsx(FormV5.$$Error.make, {
            children: imagesResult._0
          }) : null;
  }
  var match$1 = AttachmentFormUtils.anyInProgress(images);
  var match$2 = AttachmentFormUtils.anyInProgress(files);
  var tmp$1;
  var exit$1 = 0;
  if (match$1 || match$2) {
    exit$1 = 1;
  } else {
    tmp$1 = null;
  }
  if (exit$1 === 1) {
    tmp$1 = JsxRuntime.jsx(View__Jsx3.make, {
          mt: {
            NAME: "px",
            VAL: 10
          },
          children: "Uploading..."
        });
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(DragDrop.DragDropContext.make, {
                      children: JsxRuntime.jsx(DragDrop.DropArea.make, {
                            onChange: add,
                            children: match.length !== 0 ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                    children: [
                                      JsxRuntime.jsx(AttachmentFormSection$ImageUploadList, {
                                            onAddAttachments: add,
                                            onDeleteAttachment: i.delete,
                                            reorder: i.reorder,
                                            uploads: i.attachments
                                          }),
                                      JsxRuntime.jsx(AttachmentFormSection$FileUploadList, {
                                            onAddAttachments: add,
                                            onDeleteAttachment: f.delete,
                                            reorder: f.reorder,
                                            uploads: f.attachments
                                          })
                                    ]
                                  }) : JsxRuntime.jsx(InitialUploadPrompt, {
                                    onAddAttachments: add
                                  })
                          })
                    }),
                tmp,
                tmp$1
              ]
            });
}

var make = AttachmentFormSection;

exports.StyleComponents = StyleComponents;
exports.FileBar = FileBar;
exports.AttachmentItemContent = AttachmentItemContent$1;
exports.AttachmentItem = AttachmentItem$1;
exports.UploadStatus = UploadStatus;
exports.FileInputLink = FileInputLink;
exports.AddFileItem = AddFileItem;
exports.UploadList = UploadList$1;
exports.FileUploadList = FileUploadList;
exports.ImageUploadList = ImageUploadList;
exports.make = make;
/* ReactDnd Not a pure module */
